import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(public)/error.tsx");
